<div *ngFor="let node of nodes" class="list-group">
  <a href="#" class="list-group-item list-group-item-action active">
    {{ node['id']}} | {{ node['name']}}
  </a>

  <a *ngFor="let nodeElement of node['nodeElements']" [routerLink]="['/export/actions/update/',nodeElement['id'],export['id']]" class="list-group-item list-group-item-action disabled">{{ nodeElement['title']}}
  </a>
</div>
